module.exports = __webpack_public_path__ + "img/645.37855f6d.jpg";